import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { Globals } from 'src/app/shared/globals/globals';
import { Items, ItemsByEnquiryNo } from 'src/app/shared/models/data/itemsByEnquiryNo.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftToasterService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-toaster.service';
import { CalculatedCols, CustomIcoCol, MenuVoice } from 'src/app/shared/teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';
import { GridDataset } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { parseGridActionEvent } from 'src/app/shared/utils/grid-event.utils';

@Component({
  selector: 'app-modal-similar-enquiries',
  templateUrl: './modal-similar-enquiries.component.html',
  styleUrls: ['./modal-similar-enquiries.component.scss']
})
export class ModalSimilarEnquiriesComponent implements OnInit, OnDestroy {

  @Input() isMobile: boolean = false;
  @Input() projectName?: string;
  @Input() enquiryNo?: string | null;
  @Input() action: string = '';

  @Output() onSkip = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();


  oDataUrl: string = "SimilarEnquiries";
  oDataFilters: string = '';
  isLoading: boolean = true;
  columnsToHide: string[] = ['Id', "DueDateColor", "UserId", "SalesOfficeId", 'CostsStatus', 'FeasibilityStatus', 'DeliveryStatus', 'QuotationExists', 'IsQuotationFinal', 'IsQuotationExternallyUploaded', 'OdUom', 'IdUom', 'WtUom', 'TotalWeightUom'];
  columnsToShowRow: string[] = ["customerItemNo", "feasibilityStatus", "costsStatus", "deliveryStatus", "unitSystem", "sms.description", "marketFamily.name", "customerDeliveryDate", "energySurcharge", "applicableNorms", "remark", "normGrades.normGradeCode", "gradeCustomerAnalysisLimitation.limitation",
    "gradeCustomerOtherLimitation.limitation", "rawMaterialGrade.rawMaterialGradeCode", "npsSchedule.npsDescription", "od", "odTolerancePlus", "odToleranceMinus", "odToleranceUom", "id", "idTolerancePlus", "idToleranceMinus", "idToleranceUom", "wt", "typeOfTolerance", "tubeExecution.description", "wtTolerancePlus", "wtToleranceMinus", "wtToleranceUom",
    "quantity", "quantityUom", "lengthType", "multipleLength", "lengthMin", "lengthMax", "lengthNominal", "lengthUom", "uBent", "totalWeight", "totalWeightUom", "mill.shortName", "surfaceType.name", "endsCondition", "testCondition", "sql.name", "offerScheme.offerSchemeDescription", "ut", "hydroTest", "ht", "htAdditional", "inspectionType3Dot2", "multipleCutting",
    "icrIssued", "itrIssued", "idrIssued", "attachments", "fullCost", "extraCosts", "minimumFm", "recommendedFm", "customerBonus", "minimumPrice", "recommendedPrice", "actualFm", "negotiationMargin", "agentFee", "finalPrice", 'finalPricePerLength', 'alloySurchargeValue', 'energySurchargeValue', "initialPrice", "previousRevisionPrice", "deliveryDate"];
  columnsToHideItems: string[] = ['normGrades.normGradeId', 'marketingGrade.marketingGradeId', 'marketingGrade.marketingGradeCode', 'marketingGrade.isDefault', 'rawMaterialGrade.rawMaterialGradeId',
    'rawMaterialGrade.isDefault', 'npsSchedule.npsScheduleId', 'npsSchedule.nps', 'npsSchedule.schedule', 'npsSchedule.odMetric', 'npsSchedule.wtMetric', 'npsSchedule.odImperial',
    'npsSchedule.wtImperial', 'sms.smsId', 'sms.description', 'sms.marketingRoute', 'marketFamily.marketFamilyId', 'marketFamily.description', 'marketFamily.isDefaultForProject',
    'marketFamily.isDefaultForStock', 'surfaceType.surfaceTypeId', 'surfaceType.description', 'sql.sqlId', 'mill.millId', 'mill.name', 'mill.city', 'mill.country', 'marketingGrade',
    'tubeExecution.tubeExecutionId', 'tubeExecution.name', 'tubeExecution.isCustom', 'tubeExecution.toleranceMinusAw', 'tubeExecution.tolerancePlusAw',
    'tubeExecution.toleranceMinusMw', 'tubeExecution.tolerancePlusMw', 'tubeExecution.isDefaultForHot', 'tubeExecution.isDefaultForCold', 'optionDate'];

  subscriptions = new Subscription();
  customIcoCols: CustomIcoCol[] = new Array();
  selectedEnquiryNo?: string;
  foundResultsCount: number = 0;
  dataSetItems: any[] = new Array();
  enquiryItems: ItemsByEnquiryNo = new ItemsByEnquiryNo();
  calculatedCols: CalculatedCols[] = new Array();
  expandedEnquiryNo?: string | null;
  readonly: boolean = false;

  constructor(public globals: Globals, private backendService: BackendService, private translate: TranslateService, private teiasoftLoader: TeiasoftLoaderService, private teiasoftToaster: TeiasoftToasterService) {

  }

  ngOnInit(): void {
    if (this.enquiryNo && this.enquiryNo.length > 0) {
      this.checkForSimilarEnquiriesByEnquiryNo();
    }
    else {
      this.checkForSimilarEnquiriesByProjectName();
    }
    this.readonly = Boolean(this.enquiryNo && this.enquiryNo.length > 0);
    this.buildCustomIconGrid();
    this.buildCalculatedCols();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.foundResultsCount = 0;
  }

  buildCustomIconGrid() {
    this.customIcoCols = new Array();

    /* OPEN ACTION ON ENQUIRY MENU*/
    let _item: CustomIcoCol = new CustomIcoCol();

    /* EXPAND ROW */
    _item = new CustomIcoCol();
    _item.action = "expandRow|Items"; // Flag that expand the single row | obcjet to expand
    _item.icon = new Array();
    _item.icon = ['fal fa-plus', 'fal fa-minus'];
    _item.tooltip = this.translate.instant("grid.openItems");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.customIcoCols.push(_item);

  }

  buildCalculatedCols() {
    this.calculatedCols = new Array();
    /* FEASIBILITY CALCULATED COL */
    let _item: CalculatedCols = new CalculatedCols();
    _item.id = 0;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|FeasibilityStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "F";
    this.calculatedCols.push(_item);

    /* PRICE CALCULATED COL */
    _item = new CalculatedCols();
    _item.id = 1;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|CostsStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "P";
    this.calculatedCols.push(_item);

    /* DELIVERY CALCULATED COL */
    _item = new CalculatedCols();
    _item.id = 2;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|DeliveryStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "D";
    this.calculatedCols.push(_item);


  }

  customIconClick(evt: any) {
    if (evt.indexOf("|") != -1) {
      const { action: _action, row: _obj } = parseGridActionEvent(evt);
      if (_action == 'closeEnquiry') {
        this.selectedEnquiryNo = _obj["EnquiryNo"];
      }

      if (_action == 'expandRow') {
        this.enquiryItems = new ItemsByEnquiryNo();
        this.dataSetItems = new Array();
        this.getItemsByEnquiryNo(_obj["EnquiryNo"]);
        this.selectedEnquiryNo = _obj["EnquiryNo"];
      }
    }

  }

  getItemsByEnquiryNo(enquiryNo: string) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.getItemsByEnquiryNo(enquiryNo).subscribe(res => {
      this.enquiryItems = new ItemsByEnquiryNo();
      this.enquiryItems = res;
      this.fillDataSetItems(res);

      this.expandedEnquiryNo = null;
      setTimeout(() => {
        this.expandedEnquiryNo = enquiryNo;
      }, 0);
    }));
  }

  fillDataSetItems(enquiryItems: ItemsByEnquiryNo) {
    this.dataSetItems = new Array();
    for (var i = 0; i < enquiryItems.items!.length; i++) {
      let _dataSet: GridDataset = new GridDataset();
      let _obj: Items = new Items();
      _obj = enquiryItems.items![i]!;
      for (const key in _obj) {
        let _value: any = _obj[key as keyof typeof _obj];
        if (_value == null) _value = "";
        let _typeOf: string = typeof _value;
        let _key: string = "";
        if (_typeOf != 'object') {
          _dataSet[key] = _value;
        } else {
          if (Array.isArray(_value)) {
            _key = key;
            if (_value.length == 0) {
              _dataSet[_key] = '';
            }
            if (_value.length > 0 && key.toLowerCase() == 'attachments') {
              _dataSet[_key] = _value.length;
            } else {
              for (const key2 in _value[0]) {
                _key = key + "." + key2;
                //_dataSet[key2] = _value.map(x => x[key2]).join(',');
                _dataSet[_key] = _value.map(x => x[key2]).join(',');
              }
            }

          } else {
            for (const key3 in _value) {
              if (typeof _value[key3] != 'object') {
                _key = key + "." + key3;
                let _value3: any = _value[key3 as keyof typeof _value];
                //_dataSet[key3] = _value3;
                _dataSet[_key] = _value3;
              } else {
                for (const key4 in _value[key3]) {
                  _key = key + "." + key3 + "." + key4;
                  let _value4: any = _value[key3][key4]; //_value[key4 as keyof typeof key4];
                  //_dataSet[key4] = _value4;
                  _dataSet[_key] = _value4;
                }
              }
            }
          }
        }
      }
      this.dataSetItems.push(_dataSet);
    }

    this.dataSetItems = this.dataSetItems.sort(
      function (a, b) {
        return a["itemNo"]! - b["itemNo"]!;
      }
    );
    this.teiasoftLoader.stop();
  }


  checkForSimilarEnquiriesByProjectName() {
    this.subscriptions.add(this.backendService.getSimiliarEnquiriesByHeader(this.projectName!).subscribe(res => {
      if (!res || !res.enquiriesNo || res.enquiriesNo.length == 0) {
        this.teiasoftToaster.show('info', this.translate.instant('enquiryBook.noSimilarEnquiriesFound'));
        this.onSkipClick();
      }
      else {
        const formattedEnquiries = res.enquiriesNo.map(enquiry => `'${enquiry}'`).join(',');
        this.oDataFilters = `$filter=EnquiryNo in (${formattedEnquiries})`;
      }
      this.foundResultsCount = res.enquiriesNo?.length || 0;

      this.isLoading = false;
    }));
  }


  onNoMatches() {
    this.teiasoftToaster.show('info', this.translate.instant('enquiryBook.noSimilarEnquiriesFound'));
    this.onCloseClick();
  }

  checkForSimilarEnquiriesByEnquiryNo() {
    this.subscriptions.add(this.backendService.getSimiliarEnquiriesByEnquiryNo(this.enquiryNo!).subscribe(res => {
      if (!res || !res.enquiriesNo || res.enquiriesNo.length == 0) {
        this.onNoMatches();
      }
      else {
        const formattedEnquiries = res.enquiriesNo.map(enquiry => `'${enquiry}'`).join(',');
        this.oDataFilters = `$filter=EnquiryNo in (${formattedEnquiries})`;
      }
      this.foundResultsCount = res.enquiriesNo?.length || 0;
      this.isLoading = false;
    }));
  }

  onCancelClick() {
    this.onCancel.emit();
  }

  onSkipClick() {
    this.subscriptions.unsubscribe();
    this.onSkip.emit();
  }

  onCloseClick() {
    this.onClose.emit();
  }
}
